const React = require('react');
const ReactDOM = require('react-dom');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const SpringsMixin = require('../mixins/springs');
const SpringClickGroup = require('./spring-click-group.react');
const RenderingUtils = require('../utils/rendering');
const ReactModal = require('react-modal');
const Loader = require('./loader.react');
const timers = require('timers');
const createReactClass = require('create-react-class');

/**
 * Modal
 */
const Modal = createReactClass({

  propTypes: {
    children: PropTypes.node.isRequired,
    animates: PropTypes.bool,
    open: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    onRequestClose: PropTypes.func,
    modifier: PropTypes.oneOf(['error', 'centerAligned', 'noGutter']),
    actions: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      handler: PropTypes.func.isRequired,
      modifier: PropTypes.oneOf([
        'confirm', 'reject', 'primary', 'rightAligned', 'primaryRightAligned',
        'confirmRightAligned',
      ]),
    })).isRequired,
    onClosed: PropTypes.func,
    classNames: PropTypes.shape({
      modal: PropTypes.arrayOf(PropTypes.string),
    }),
  },

  mixins: [
    SpringsMixin([
      {
        key: 'modal',
        tension: 200,
        friction: 15,
        initialValue: 0,
      },
    ]),
  ],

  getDefaultProps() {
    return {
      classNames: {},
      animates: true,
    };
  },

  componentDidMount() {
    document.addEventListener('mousedown', this.handleMouseClickOutside);
    if (this.props.open) {
      this._openModal();
    }
  },

  UNSAFE_componentWillReceiveProps(newProps) {
    if (!this.props.open && newProps.open) {
      this._openModal();
    } else if (this.props.open && !newProps.open) {
      this._closeModal();
    }

    this.springRefs.modal.setOvershootClampingEnabled(this.props.animates);
  },

  UNSAFE_componentWillUpdate(_, nextState) {
    if (!this.state.isShaking && nextState.isShaking) {
      const shakeEndHandler = () => {
        this.setState({
          isShaking: false,
        });

        this.refs.content.removeEventListener('animationend', shakeEndHandler);
      };

      this.refs.content.addEventListener('animationend', shakeEndHandler);
    }
  },

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleMouseClickOutside);
  },

  shake() {
    if (!this.props.animates) {
      return;
    }

    this.setState({
      isShaking: true,
    });
  },

  _openModal() {
    this.springRefs.modal.setEndValue(1);

    const openListener = {

      onSpringUpdate: () => {

        // this is a little weird. want to short circuit instead of waiting
        // for the object to be at rest completely

        if (this.springRefs.modal.getCurrentValue() >= 0.2) {
          this.setState({
            opening: true,
          });
        }
      },

      onSpringAtRest: () => {
        this.setState({
          opening: false,
          opened: true,
        });

        timers.setImmediate(() => {
          this.springRefs.modal.removeListener(openListener);
        });
      },
    };

    this.springRefs.modal.addListener(openListener);
  },

  _closeModal() {
    this.springRefs.modal.setEndValue(0);

    this.setState({
      closing: true,
    });

    const closeListener = {

      onSpringUpdate: () => {

        // this is a little weird. want to short circuit instead of waiting
        // for the object to be at rest completely

        if (this.springRefs.modal.getCurrentValue() < 0.1) {
          this.setState({
            closing: false,
          });

          timers.setImmediate(() => {
            this.springRefs.modal.removeListener(closeListener);
          });

          if (this.props.onClosed) {
            this.props.onClosed();
          }
        }
      },
    };

    this.springRefs.modal.addListener(closeListener);
  },

  handleMouseClickOutside(e) {
    if (!this.props.open || this.props.loading) return;

    const content = ReactDOM.findDOMNode(this.refs.content);

    // Don't handle the click if it's inside the modal's content.
    if (RenderingUtils.isNodeInRoot(e.target, content)) return;

    // HACK(gavin): Don't handle the click if the target is not a descendant of the modal overlay.
    // For example, if there's an error dialog which is shown over the modal and the user cliks
    // inside of that dialog we shouldn't try to close the modal.
    const modalOverlay = RenderingUtils.findAncestorWithClassName(content, 'ReactModal__Overlay');
    if (!RenderingUtils.isNodeInRoot(e.target, modalOverlay)) return;

    e.stopPropagation();
    if (this.props.onRequestClose) {
      this.props.onRequestClose();
    }
  },

  render() {

    const actionList = this.props.actions.map((action) => {
      const classes = classNames('Modal-control', {
        [`Modal-control--${ action.modifier }`]: action.modifier,
      });

      return <a key={ action.key } className={ classes } onClick={ action.handler }>{ action.label }</a>;
    });

    const actionListDisplay = actionList.length ? (
      <SpringClickGroup
        context={ this }
        style={ { 'display': 'flex' } }
      >
        { actionList }
      </SpringClickGroup>
    ) : null;

    const loaderDisplay = (
      <div className="Modal-loaderContainer">
        <Loader />
      </div>
    );

    const actionDisplay = this.props.loading ? loaderDisplay : actionListDisplay;

    let modalActions;
    if (actionListDisplay) {
      modalActions = (
        <div className="Modal-actions">
          { actionDisplay }
        </div>
      );
    }

    const style = this.props.animates ? {
      transform: `scale(${ this.state.modalSpringValue })`,
      WebkitTransform: `scale(${ this.state.modalSpringValue })`,
    } : {};

    const modalClasses = classNames('Modal', this.props.classNames.modal, {
      'is-shaking': this.state.isShaking,
      [`Modal--${ this.props.modifier }`]: this.props.modifier,
    });

    const backgroundClasses = classNames('Modal-background', {
      'is-visible': (this.state.opening || this.state.opened) && !this.state.closing,
    });

    // react-modal decided to inline styles (whywhywhy), which
    // we remove here.
    // https://github.com/rackt/react-modal/pull/58
    const overrideStyle = {
      overlay: {
        backgroundColor: 'none',
      },
      content: {
        border: 'none',
        background: 'none',
      },
    };

    return (
      <ReactModal style={ overrideStyle } isOpen={ this.state.closing || this.props.open } onRequestClose={ this.props.onRequestClose } contentLabel="Modal">
        <div className={ backgroundClasses }>
          <div className={ modalClasses } style={ style } ref="content">
            <div className="Modal-content">
              { this.props.children }
            </div>
            { modalActions }
          </div>
        </div>
      </ReactModal>
    );
  },
});

module.exports = Modal;
